import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/w3eraacademy_nextjsapp/src/components/assignments/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/w3eraacademy_nextjsapp/src/components/header/index.jsx");
